import { inject } from '@angular/core';
import { DemosService } from 'core/services/demos.service';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';

export const DemoCoursesResolver: ResolveFn<any> = (
  route?: ActivatedRouteSnapshot,
  state?: RouterStateSnapshot,
  demosService: DemosService = inject(DemosService)
): Promise<any> => {
  return new Promise((resolve) => {
    resolve(demosService.loadDemoCoursesCache());
  });
};
